import { c as _c } from "react/compiler-runtime";
import { Link } from "../../ui/Link";
import { cn } from "@local/utils/src/cn";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import { barlowCondensed } from "../../../utils/fonts";
import type { Offer } from "@local/offer/src/types";
import type { SweepstakesState } from "@local/offer/src/lib/const/sweepstakes";
import { EntriesBadge } from "@local/offer/src/components/sweepstakes/EntriesBadge";
import type { Route } from "next";
import { DiscountPrice } from "./DiscountPrice";
export interface BestSellersBigBlockProps {
  product: Offer.BlockListing;
  mobileImage?: Offer.BlockMedia;
  market?: string;
  /**
   * Scheduled campaign state, resolved on the server. Passed in so SSR and
   * hydration render the same state; the client re-resolves it after mount.
   */
  sweepstakesState?: SweepstakesState;
}
export const BestSellersBigBlock = t0 => {
  const $ = _c(36);
  const {
    product,
    mobileImage,
    market,
    sweepstakesState
  } = t0;
  const productUrl = `/${market}/product/${product.slug}`;
  const headingId = `bestseller-big-${product.instanceId}-name`;
  const t1 = mobileImage ? "hidden md:block" : "";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("h-full w-full transition-transform duration-300 ease-in-out group-hover:scale-105 motion-reduce:transition-none", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = product.image?.url ?? "";
  let t4;
  if ($[2] !== t3) {
    t4 = getCdnUrl({
      src: t3
    });
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `url(${t4})`;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      backgroundImage: t5,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t2 || $[7] !== t6) {
    t7 = <div className={t2} style={t6} />;
    $[6] = t2;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== mobileImage) {
    t8 = mobileImage && <div className="h-full w-full transition-transform duration-300 ease-in-out group-hover:scale-105 motion-reduce:transition-none md:hidden" style={{
      backgroundImage: `url(${getCdnUrl({
        src: mobileImage.url ?? ""
      })})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }} />;
    $[9] = mobileImage;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== market || $[12] !== product.prices?.[0]?.discountValue || $[13] !== product.prices?.[0]?.value || $[14] !== sweepstakesState) {
    t9 = market && sweepstakesState && <EntriesBadge market={market} priceInMinorUnits={product.prices?.[0]?.discountValue ?? product.prices?.[0]?.value ?? 0} scheduled={sweepstakesState} />;
    $[11] = market;
    $[12] = product.prices?.[0]?.discountValue;
    $[13] = product.prices?.[0]?.value;
    $[14] = sweepstakesState;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== headingId || $[17] !== product.name) {
    t10 = <h3 id={headingId} className={`${barlowCondensed.className} text-4xl font-semibold uppercase lg:text-5xl`}>{product.name}</h3>;
    $[16] = headingId;
    $[17] = product.name;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== market || $[20] !== product.prices) {
    t11 = product.prices?.[0] && <DiscountPrice price={product.prices[0]} className="pt-2 text-2xl" market={market} onDark={true} />;
    $[19] = market;
    $[20] = product.prices;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <div className="w-11/12 py-5 pl-5 md:w-10/12 lg:w-9/12">{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t9) {
    t13 = <div className="pointer-events-none absolute bottom-0 left-0 w-full bg-gradient-to-b from-transparent to-gray-950">{t9}{t12}</div>;
    $[25] = t12;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = productUrl as Route;
  let t15;
  if ($[28] !== headingId || $[29] !== t14) {
    t15 = <Link href={t14} prefetch={false} aria-labelledby={headingId} className="absolute inset-0 rounded-sm focus-visible:ring-2 focus-visible:ring-gray-700 focus-visible:ring-offset-2 focus-visible:outline-hidden" />;
    $[28] = headingId;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t13 || $[32] !== t15 || $[33] !== t7 || $[34] !== t8) {
    t16 = <article className="group relative h-full w-full overflow-hidden text-white"><div className="relative h-full w-full">{t7}{t8}{t13}{t15}</div></article>;
    $[31] = t13;
    $[32] = t15;
    $[33] = t7;
    $[34] = t8;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};